export default __webpack_public_path__ + "ff992e666536a3ab3ae44711ca1b6b76.svg";